import { API_UNPROTECTED } from '@api/apiUnprotected';
import { AxiosResponse } from 'axios';
import { AffordabilityEvaluationDto } from '@pages/CalculatorPage/types';
import { AffordabilityEvaluationResponse } from './types';
import { ServerError } from '../../errors/server-error';

export const affordabilityProxyApi = {
  getAffordabilityEvaluation: async (
    formDataDto: AffordabilityEvaluationDto,
  ): Promise<AffordabilityEvaluationResponse[]> => {
    try {
      const response = await API_UNPROTECTED.post<
        AffordabilityEvaluationDto,
        AxiosResponse<AffordabilityEvaluationResponse[]>
      >('/affordabilityProxy/evaluate', formDataDto, { headers: { 'Content-Type': 'application/json' } });

      return response.data;
    } catch (err: any) {
      const { message = 'Internal Server Error' } = err.response.data || err.response.statusText;
      const { status = 500 } = err.response;

      throw new ServerError(status, message);
    }
  },
};
